export const TOP_PICK_FARM_SIZE = 24;
export const BUNDLE_CONTENT_TYPE = 'plantBundle';
export const BUNDLE_MIX_CONTENT_TYPE = 'buyable';
